import Header from './components/Header';
import Footer from './components/Footer';
import Seo from './components/Seo';
import { OrganizationSchema, LocalBusinessSchema } from './components/SchemaMarkup';
import HeroSection from './components/home/HeroSection';
import TrustStrip from './components/home/TrustStrip';
import AboutSection from './components/home/AboutSection';
import ServicesSection from './components/home/ServicesSection';
import WhyChooseUsSection from './components/home/WhyChooseUsSection';
import TeamSection from './components/home/TeamSection';
import TestimonialsSection from './components/home/TestimonialsSection';
import NewsletterSection from './components/home/NewsletterSection';

function App() {
  return (
    <div className="font-sans text-black">
      <Seo
        title="Moreflex Aviation | VIP Airport Meet & Greet, Lounge, Chauffeur Services"
        description="Moreflex Aviation delivers premium VIP airport services in Kenya and beyond: meet & greet, lounge access, chauffeur and fleet services, and baggage assistance. 24/7 support in 135+ countries."
        path="/"
      />
      <OrganizationSchema />
      <LocalBusinessSchema />
      <Header />
      <HeroSection />
      <TrustStrip />
      <AboutSection />
      <ServicesSection />
      <WhyChooseUsSection />
      <TeamSection />
      <TestimonialsSection />
      <NewsletterSection />
      <Footer />
    </div>
  );
}

export default App;
